import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

// Pages
import HomePage from "@/pages/HomePage";
import ArticlePage from "@/pages/ArticlePage";
import CategoryPage from "@/pages/CategoryPage";
import MentionsLegalesPage from "@/pages/MentionsLegalesPage";
import ArchivesPage from "@/pages/ArchivesPage";
import NumerosPage from "@/pages/NumerosPage";
import NumeroDetailPage from "@/pages/NumeroDetailPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import GuidePage from "@/pages/GuidePage";
import GuideIndexPage from "@/pages/GuideIndexPage";
import FAQPage from "@/pages/FAQPage";

// Components
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import PetitPageBot from "@/components/PetitPageBot";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="min-h-screen flex flex-col bg-stone-100">
            <Routes>
              {/* Admin routes without header/footer */}
              <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/*" element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            
            {/* Archives */}
            <Route path="/archives" element={<ArchivesPage />} />
            <Route path="/numeros" element={<NumerosPage />} />
            <Route path="/numero/:numero" element={<NumeroDetailPage />} />
            
            {/* Guide touristique - FR */}
            <Route path="/guide" element={<GuideIndexPage />} />
            <Route path="/visiter-versailles" element={<GuidePage />} />
            <Route path="/chateau-de-versailles" element={<GuidePage />} />
            <Route path="/jardins-de-versailles" element={<GuidePage />} />
            <Route path="/grand-trianon" element={<GuidePage />} />
            <Route path="/petit-trianon" element={<GuidePage />} />
            <Route path="/hameau-de-la-reine" element={<GuidePage />} />
            <Route path="/galerie-des-glaces" element={<GuidePage />} />
            <Route path="/que-faire-a-versailles" element={<GuidePage />} />
            <Route path="/versailles-en-1-jour" element={<GuidePage />} />
            <Route path="/versailles-en-2-jours" element={<GuidePage />} />
            <Route path="/versailles-avec-des-enfants" element={<GuidePage />} />
            <Route path="/versailles-quand-il-pleut" element={<GuidePage />} />
            <Route path="/ou-manger-a-versailles" element={<GuidePage />} />
            <Route path="/ou-dormir-a-versailles" element={<GuidePage />} />
            <Route path="/comment-venir-a-versailles" element={<GuidePage />} />
            <Route path="/visiter-versailles-depuis-paris" element={<GuidePage />} />
            
            {/* Multilingual guides - EN */}
            <Route path="/en/guide" element={<GuideIndexPage />} />
            <Route path="/en/:slug" element={<GuidePage />} />
            
            {/* Multilingual guides - ES */}
            <Route path="/es/guide" element={<GuideIndexPage />} />
            <Route path="/es/:slug" element={<GuidePage />} />
            
            {/* Multilingual guides - DE */}
            <Route path="/de/guide" element={<GuideIndexPage />} />
            <Route path="/de/:slug" element={<GuidePage />} />
            
            {/* Multilingual guides - IT */}
            <Route path="/it/guide" element={<GuideIndexPage />} />
            <Route path="/it/:slug" element={<GuidePage />} />
            
            {/* Multilingual guides - JA */}
            <Route path="/ja/guide" element={<GuideIndexPage />} />
            <Route path="/ja/:slug" element={<GuidePage />} />
            
            {/* FAQ Pages - Multilingual */}
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/en/faq" element={<FAQPage />} />
            <Route path="/es/faq" element={<FAQPage />} />
            <Route path="/de/faq" element={<FAQPage />} />
            <Route path="/it/faq" element={<FAQPage />} />
            <Route path="/ja/faq" element={<FAQPage />} />
            <Route path="/zh/faq" element={<FAQPage />} />
            <Route path="/:lang/faq" element={<FAQPage />} />
            
            {/* Public routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/article/:slug" element={<ArticlePage />} />
            <Route path="/categorie/:category" element={<CategoryPage />} />
            <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
          </Routes>
          <Toaster position="bottom-right" />
          
          {/* Petit Page Bot - Widget flottant sur toutes les pages */}
          <PetitPageBot />
        </div>
      </BrowserRouter>
    </AuthProvider>
  </HelmetProvider>
  );
}

export default App;
